export default __webpack_public_path__ + "static/media/2368.920442b9.png";